/* eslint-disable jsx-a11y/anchor-is-valid */
import type { FC } from "react";
import { HiOutlineUser, HiOutlineLocationMarker, HiOutlineCube } from "react-icons/hi";
import { cn } from "@design-system";

export interface DropdownSearchListItemProp {
  title: string;
  subtitle?: string;
  id: string;
  selected?: boolean;
  inlineSubtitle?: boolean;
  buttonClickEvent?: (id: string) => void;
  iconType?: "user" | "location" | "product";
}

export const DropdownSearchListItem: FC<DropdownSearchListItemProp> = (
  props,
) => {
  const handleButtonClick = () => {
    if (props.buttonClickEvent) {
      props.buttonClickEvent(props.id);
    }
  };

  const renderIcon = () => {
    switch (props.iconType) {
      case "location":
        return (
          <HiOutlineLocationMarker
            className="text-gray-700 dark:text-gray-300"
            size={16}
          />
        );
      case "product":
        return (
          <HiOutlineCube
            className="text-gray-700 dark:text-gray-300"
            size={16}
          />
        );
      case "user":
      default:
        return (
          <HiOutlineUser
            className="text-gray-700 dark:text-gray-300"
            size={16}
          />
        );
    }
  };

  return (
    <li
      className={cn(
        "py-2 cursor-pointer dark:text-white hover:text-lgb-primary dark:hover:bg-[#0e1432] dark:hover:text-white transition-colors",
        props.selected && "text-lgb-primary dark:text-lgb-primary",
      )}
      onClick={handleButtonClick}
    >
      <div className="flex items-center space-x-4">
        <div className="flex-shrink-0">{renderIcon()}</div>
        {props.inlineSubtitle && (
          <div className="flex gap-2">
            <p className={"text-md font-medium dark:text-white"}>
              {props.title + " "}
              <span className={"text-md font-normal opacity-70 dark:text-gray-300"}>
                ({props.subtitle || ""})
              </span>
            </p>
          </div>
        )}
        {!props.inlineSubtitle && (
          <p className={"text-md font-medium dark:text-white"}>
            {props.title + " "}
            <span className={"text-md font-normal opacity-70 dark:text-gray-300"}>
              {props.subtitle}
            </span>
          </p>
        )}
      </div>
    </li>
  );
};
